import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface CardProps {
  title?: ReactNode;
  action?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
}

export function Card({ title, action, className, bodyClassName, children }: CardProps) {
  return (
    <div className={cn("rounded-lg border bg-card shadow-sm", className)}>
      {(title || action) && (
        <div className="flex items-center justify-between border-b px-4 py-3">
          {title && <h2 className="text-sm font-semibold text-foreground">{title}</h2>}
          {action && <div className="text-sm text-muted-foreground">{action}</div>}
        </div>
      )}
      <div className={cn("p-4", bodyClassName)}>{children}</div>
    </div>
  );
}
